import { useContext } from "react";
import { LogContext } from "../../components/LogProvider/LogProvider";
import { LogContextType } from "../../types/ciptex-sdk";

export const useLogContext = (): LogContextType => {
	const context = useContext(LogContext);
	if (!context) {
		throw new Error("useLogContext must be used within a LogProvider");
	}
	return context;
}